// src/utils/auth.js
import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "token";
const TAB_KEY = "tabId";

function uuid4() {
  // A lógica original foi mantida, mas com parênteses adicionados
  // para respeitar a precedência de operadores (Divisão > Shift > AND > XOR)
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

// 🔹 ID único por ABA (fica em sessionStorage)
export function getTabId() {
  let id = sessionStorage.getItem(TAB_KEY);
  if (!id) {
    id = uuid4();
    sessionStorage.setItem(TAB_KEY, id);
  }
  return id;
}

export function saveToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// <<< ALTERAÇÃO AQUI >>>
// Agora usa localStorage.clear() para remover TUDO
// e resolver a anomalia de dados contaminados.
export function logout() {
  localStorage.clear();
  // Isso não afeta o sessionStorage, então o tabId é mantido.
}

export function decodeToken() {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isTokenValid() {
  const decoded = decodeToken();
  if (!decoded || !decoded.exp) return false;
  const now = Date.now() / 1000;
  return decoded.exp > now;
}

export function getAuthInfo() {
  const decoded = decodeToken();
  if (!decoded) return null;
  const { alias, exp } = decoded;
  return { alias, expiresAt: exp };
}

export function formatTime(tsSeconds) {
  if (!tsSeconds) return "";
  const date = new Date(tsSeconds * 1000);
  return date.toLocaleTimeString();
}

// 🔐 sessionId do JWT (setado no backend)
export function getSessionId() {
  const d = decodeToken();
  return d?.sessionId ?? null;
}